"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f111 = void 0;
exports.f111 = {
    "otuo": [
        8
    ],
    "otwa": [
        8
    ],
    "oyan": [
        17
    ],
    "of": [
        472,
        1969,
        2336,
        489,
        495,
        674,
        754,
        766,
        767,
        768,
        769,
        770,
        894,
        899,
        1060,
        2044,
        2398,
        2555,
        2923,
        2997,
        2998,
        3178,
        3281,
        3518,
        3569,
        3668,
        3814,
        3889,
        4001,
        4222,
        4223,
        4276,
        4347,
        4748,
        4942,
        5082,
        5358,
        5405,
        5423,
        5453,
        5772,
        5991,
        5992,
        6310,
        6345,
        6400,
        6462,
        6995,
        6996,
        7026,
        7220,
        7271,
        7272,
        7273,
        7592,
        7930,
        8123,
        8124,
        8580,
        8673,
        8722,
        9055,
        9058,
        9103,
        9184,
        24,
        112,
        113,
        114,
        157,
        281,
        424,
        435,
        460,
        480,
        497,
        534,
        593,
        596,
        599,
        638,
        646,
        679,
        700,
        703,
        740,
        834,
        849,
        858,
        859,
        889,
        903,
        919,
        945,
        950,
        955,
        980,
        994,
        1007,
        1019,
        1033,
        1058,
        1070,
        1083,
        1091,
        1121,
        1176,
        1190,
        1233,
        1241,
        1244,
        1254,
        1279,
        1309,
        1311,
        1378,
        1445,
        1497,
        1703,
        1705,
        1796,
        1812,
        1840,
        1867,
        1916,
        1923,
        1933,
        1942,
        2049,
        2065,
        2101,
        2152,
        2164,
        2216,
        2290,
        2329,
        2347,
        2348,
        2389,
        2401,
        2412,
        2426,
        2496,
        2564,
        2613,
        2656,
        2680,
        2681,
        2700,
        2730,
        2749,
        2750,
        2752,
        2826,
        2845,
        2872,
        2884,
        2898,
        2901,
        2906,
        2909,
        2911,
        2925,
        2927,
        2956,
        2957,
        2982,
        3031,
        3057,
        3067,
        3083,
        3191,
        3238,
        3255,
        3355,
        3374,
        3378,
        3391,
        3410,
        3416,
        3486,
        3526,
        3527,
        3528,
        3531,
        3533,
        3535,
        3537,
        3561,
        3604,
        3620,
        3631,
        3656,
        3657,
        3667,
        3689,
        3693,
        3732,
        3744,
        3753,
        3773,
        3817,
        3845,
        3847,
        3848,
        3849,
        3850,
        3866,
        3880,
        3885,
        3905,
        3955,
        3975,
        3987,
        3993,
        4005,
        4023,
        4055,
        4090,
        4096,
        4132,
        4183,
        4195,
        4204,
        4266,
        4269,
        4274,
        4284,
        4306,
        4312,
        4328,
        4334,
        4348,
        4363,
        4401,
        4419,
        4438,
        4445,
        4450,
        4454,
        4456,
        4475,
        4481,
        4489,
        4492,
        4517,
        4518,
        4524,
        4541,
        4548,
        4592,
        4660,
        4661,
        4662,
        4664,
        4666,
        4667,
        4710,
        4757,
        4759,
        4762,
        4763,
        4764,
        4765,
        4770,
        4823,
        4855,
        4925,
        4984,
        5051,
        5171,
        5178,
        5202,
        5203,
        5204,
        5212,
        5234,
        5254,
        5269,
        5313,
        5331,
        5364,
        5365,
        5367,
        5368,
        5369,
        5377,
        5380,
        5421,
        5422,
        5432,
        5434,
        5435,
        5474,
        5479,
        5490,
        5491,
        5495,
        5528,
        5530,
        5533,
        5549,
        5553,
        5583,
        5592,
        5609,
        5633,
        5638,
        5687,
        5715,
        5717,
        5724,
        5728,
        5746,
        5748,
        5775,
        5789,
        5793,
        5796,
        5799,
        5803,
        5811,
        5814,
        5873,
        5877,
        5882,
        5884,
        5892,
        5908,
        5910,
        6021,
        6028,
        6055,
        6100,
        6101,
        6108,
        6147,
        6162,
        6169,
        6204,
        6252,
        6258,
        6267,
        6275,
        6285,
        6309,
        6371,
        6443,
        6474,
        6491,
        6495,
        6524,
        6560,
        6568,
        6574,
        6585,
        6621,
        6624,
        6638,
        6639,
        6661,
        6668,
        6669,
        6670,
        6701,
        6703,
        6706,
        6753,
        6780,
        6821,
        6832,
        6844,
        6852,
        6887,
        6932,
        6953,
        6959,
        6976,
        6977,
        6986,
        6987,
        7027,
        7028,
        7035,
        7038,
        7039,
        7048,
        7080,
        7126,
        7130,
        7181,
        7188,
        7193,
        7194,
        7205,
        7223,
        7224,
        7225,
        7230,
        7231,
        7232,
        7234,
        7235,
        7275,
        7287,
        7315,
        7341,
        7347,
        7357,
        7418,
        7503,
        7534,
        7549,
        7572,
        7609,
        7636,
        7652,
        7655,
        7774,
        7879,
        7949,
        8047,
        8061,
        8082,
        8086,
        8111,
        8144,
        8179,
        8180,
        8181,
        8246,
        8308,
        8309,
        8316,
        8366,
        8494,
        8500,
        8505,
        8529,
        8561,
        8604,
        8659,
        8660,
        8735,
        8774,
        8843,
        8861,
        8867,
        8878,
        8979,
        8980,
        9012,
        9056,
        9057,
        9074,
        9082,
        9086,
        9096,
        9097,
        9099,
        9106,
        9108,
        9148
    ],
    "ossouon": [
        54
    ],
    "omani": [
        82,
        136
    ],
    "omani arabic": [
        82
    ],
    "omani hadari arabic": [
        82
    ],
    "om": [
        82,
        91,
        423,
        820,
        3026,
        3063,
        4538,
        6857,
        9176
    ],
    "oman": [
        82,
        91,
        423,
        820,
        3026,
        3063,
        4538,
        6857,
        9176
    ],
    "omani bedawi arabic": [
        136
    ],
    "obokuitai": [
        149
    ],
    "obogwitai": [
        149
    ],
    "oprou": [
        190
    ],
    "oyaricoulet": [
        245
    ],
    "oakuem": [
        251
    ],
    "okum": [
        251
    ],
    "okim": [
        264
    ],
    "olyutor": [
        274
    ],
    "oirot": [
        275,
        276
    ],
    "oyrot": [
        275,
        276
    ],
    "oru": [
        279,
        1993
    ],
    "omagé": [
        288
    ],
    "old english (ca. 450-1100)": [
        321
    ],
    "old": [
        321,
        2470,
        2731,
        5631,
        5824,
        5825,
        5831,
        5832,
        5836,
        5837,
        5838,
        5842,
        5845,
        5846,
        5850,
        5854,
        5855,
        5856,
        5864,
        5881,
        5884,
        5890,
        5898,
        5913,
        5914,
        5918,
        5919,
        5935,
        5941,
        5961,
        5974,
        5976,
        5979,
        5981,
        5985,
        5996,
        6001,
        6002,
        6006,
        6101,
        6295,
        6805,
        6806,
        1632,
        1677,
        1678,
        1679,
        2914,
        3550,
        3551,
        3552,
        5008,
        5699,
        5758,
        5759,
        5760,
        5761,
        5762,
        5892,
        6288,
        7847,
        8911
    ],
    "obolo": [
        328
    ],
    "obonya": [
        339
    ],
    "olem": [
        350
    ],
    "orang gunung": [
        366
    ],
    "orang": [
        5955,
        5958,
        366,
        696,
        736,
        1902,
        2009,
        3313,
        3838,
        3839,
        4046,
        4244,
        5193,
        5194,
        6896,
        6972,
        9089
    ],
    "ollero": [
        378
    ],
    "otogé": [
        382
    ],
    "oupinagee": [
        382
    ],
    "ocidentais": [
        382
    ],
    "orop": [
        387
    ],
    "opotai": [
        392
    ],
    "official aramaic (700-300 bce)": [
        435,
        436,
        437,
        438
    ],
    "official": [
        435,
        436,
        437,
        438,
        4736,
        4738
    ],
    "oegs": [
        475
    ],
    "okphela": [
        491
    ],
    "oewaku": [
        507
    ],
    "orotani": [
        507
    ],
    "one, molmo": [
        521
    ],
    "one": [
        521,
        5858,
        5880,
        5926,
        5931,
        5978
    ],
    "onele": [
        521,
        5858,
        5926,
        5931,
        5978
    ],
    "oni": [
        521,
        5858,
        5880,
        5926,
        5931,
        5978
    ],
    "oser": [
        558,
        564
    ],
    "oyuwu": [
        577
    ],
    "oaxaca": [
        1440,
        1524,
        5205,
        5466,
        603,
        4819,
        5224,
        8646
    ],
    "oaxaca amuzgo": [
        603
    ],
    "occidente": [
        605,
        4901
    ],
    "oki": [
        615
    ],
    "osa nanga": [
        615
    ],
    "osa": [
        615
    ],
    "ost-oberdeutsch": [
        625
    ],
    "owera": [
        665
    ],
    "ohumono": [
        678
    ],
    "orang laut": [
        696,
        2009,
        4244,
        5193,
        5194,
        5958,
        6972
    ],
    "oroko": [
        705
    ],
    "oroko-east": [
        705
    ],
    "oroko-west": [
        705
    ],
    "orang betawi": [
        736
    ],
    "odiai": [
        812
    ],
    "oviedo": [
        847
    ],
    "ovioba": [
        847
    ],
    "orambul": [
        884
    ],
    "okpele": [
        907
    ],
    "oe cusi": [
        908
    ],
    "oe": [
        908,
        6595
    ],
    "oecusse": [
        908
    ],
    "oecussi": [
        908
    ],
    "oekusi": [
        908
    ],
    "okii": [
        909
    ],
    "osikom": [
        909
    ],
    "osukam": [
        909
    ],
    "oh": [
        921
    ],
    "oule": [
        960,
        1022
    ],
    "ogoda": [
        1003
    ],
    "oriomo": [
        1013,
        2592
    ],
    "orowe": [
        1034
    ],
    "oniyan": [
        1118
    ],
    "oneyan": [
        1118
    ],
    "onian": [
        1118
    ],
    "onëyan": [
        1118
    ],
    "oka": [
        1129
    ],
    "ogoi": [
        1205
    ],
    "ongota": [
        1252
    ],
    "obanliku": [
        1321
    ],
    "ovand": [
        1322
    ],
    "ovande": [
        1322
    ],
    "ovando": [
        1322
    ],
    "omagua": [
        5907,
        1354
    ],
    "oluchiga": [
        1435
    ],
    "orukiga": [
        1435
    ],
    "ojitlán": [
        1444
    ],
    "ojitlán chinantec": [
        1444
    ],
    "ozumacín": [
        1461
    ],
    "ozumacín chinantec": [
        1461
    ],
    "ojibwe": [
        5859,
        5860,
        5861,
        5862,
        5865,
        5866,
        5868,
        5869,
        5994,
        1475,
        1476,
        5863
    ],
    "ojibway": [
        1475,
        1476,
        5859,
        5860,
        5861,
        5862,
        5863,
        5865,
        5866,
        5868,
        5869,
        5994
    ],
    "ojibwa": [
        5859,
        5860,
        5861,
        5862,
        5863,
        5868,
        5869,
        1475,
        1476,
        5865,
        5866,
        5994
    ],
    "oriental": [
        1528,
        1710,
        5449,
        5987,
        7881,
        7882
    ],
    "oo-pu": [
        1542
    ],
    "oeste": [
        1555,
        1644,
        1682,
        3091,
        3100,
        3307,
        3399,
        4571,
        4815,
        6354,
        7303,
        8971
    ],
    "ong pulu": [
        1560
    ],
    "ong": [
        5938,
        1560,
        5939,
        8332,
        8470
    ],
    "okere": [
        1589
    ],
    "ocmsl": [
        1632
    ],
    "old chiang mai sign language": [
        1632
    ],
    "old chiangmai sign language": [
        1632
    ],
    "original chiang mai sign language": [
        1632
    ],
    "original": [
        1632
    ],
    "original chiangmai sign language": [
        1632
    ],
    "ohlone, southern": [
        1649
    ],
    "ohlone": [
        1649,
        1650
    ],
    "ohlone, northern": [
        1650
    ],
    "omaškêkowak": [
        1652
    ],
    "omushkego": [
        1652
    ],
    "occidental": [
        3144,
        1656,
        1669,
        1716,
        2810,
        3719,
        5464,
        6354,
        8103,
        8970
    ],
    "old bulgarian": [
        1677,
        1678,
        1679
    ],
    "old church slavonic": [
        1677,
        1678,
        1679
    ],
    "old slavonic": [
        1677,
        1678,
        1679
    ],
    "od": [
        1724,
        5841,
        8188
    ],
    "oualo": [
        1766
    ],
    "ontario delaware": [
        1802
    ],
    "ontario": [
        1802
    ],
    "oregu": [
        1810
    ],
    "oludhimba": [
        1836
    ],
    "oluthimba": [
        1836
    ],
    "oluzimba": [
        1836
    ],
    "otjidhimba": [
        1836
    ],
    "ovazimba": [
        1836
    ],
    "oum": [
        1870
    ],
    "okanisi tongo": [
        1878,
        1879
    ],
    "okanisi": [
        1878,
        1879
    ],
    "orang sungai": [
        1902
    ],
    "oeringoep": [
        1928
    ],
    "oriya": [
        5948,
        5949,
        5959,
        7066,
        1974
    ],
    "oru yille": [
        1993
    ],
    "orang kuala": [
        2009
    ],
    "orlow": [
        2043
    ],
    "oron": [
        2052,
        2241,
        5963
    ],
    "onumu egon": [
        2069
    ],
    "onumu": [
        2069
    ],
    "oshima": [
        6646,
        2071
    ],
    "olkoi": [
        2097
    ],
    "ocean": [
        2166
    ],
    "outlying": [
        2218
    ],
    "ogea": [
        2249
    ],
    "ogia": [
        2249
    ],
    "obang": [
        2313
    ],
    "orich": [
        2317,
        2318
    ],
    "owenke": [
        2320,
        2321,
        2322
    ],
    "oasnun": [
        2349
    ],
    "oasnün": [
        2349
    ],
    "orkon": [
        2405
    ],
    "old french (842-ca. 1400)": [
        2470
    ],
    "oostfreesk": [
        2474
    ],
    "ostfriesisch": [
        2474
    ],
    "ostfriesisch-niederdeutsch": [
        2474
    ],
    "onage": [
        2500
    ],
    "oromo, borana-arsi-guji": [
        2534,
        2535,
        2536,
        2537
    ],
    "oromo": [
        2534,
        2535,
        2536,
        2537,
        2886,
        5900,
        5901,
        5902,
        5903
    ],
    "oromo, borana-arsi-guji - borana": [
        2536
    ],
    "oromo, borana-arsi-guji - guji": [
        2537
    ],
    "offra": [
        2562
    ],
    "ophra": [
        2562
    ],
    "ollar": [
        2575,
        2576
    ],
    "ollar gadaba": [
        2575,
        2576
    ],
    "ollari": [
        2575,
        2576
    ],
    "ollaro": [
        2575,
        2576
    ],
    "oikand": [
        2671
    ],
    "old high german (ca. 750-1050)": [
        2731
    ],
    "oranais-gourara": [
        2775
    ],
    "owinia": [
        2840
    ],
    "ogwia": [
        2841
    ],
    "olugwere": [
        2852
    ],
    "oamu": [
        2854
    ],
    "ongabula": [
        2861
    ],
    "ourami": [
        2884
    ],
    "oromo, eastern": [
        2886
    ],
    "oluhaya": [
        2909
    ],
    "oluhâya": [
        2909
    ],
    "oruhaya": [
        2909
    ],
    "olu-haya": [
        2909
    ],
    "old hebrew": [
        2914
    ],
    "oshikwankala haiǁom": [
        2928
    ],
    "oshikwankala": [
        2928
    ],
    "ouni": [
        3037
    ],
    "obersorbisch": [
        3058
    ],
    "ombeyajts": [
        3075,
        3097
    ],
    "ombeayiüts": [
        3091,
        3100
    ],
    "ochiherero": [
        3108
    ],
    "otjiherero": [
        3108
    ],
    "otjihimba": [
        3108
    ],
    "otshiherero": [
        3108
    ],
    "ovaherero": [
        3108
    ],
    "obani": [
        3126
    ],
    "okoloba": [
        3126
    ],
    "okuloma": [
        3126
    ],
    "olulumo-ikom": [
        3182
    ],
    "ogang": [
        3283,
        3284,
        3285,
        3286,
        3287
    ],
    "orang hulu": [
        3313
    ],
    "oubatch": [
        3324
    ],
    "odiennekakan": [
        3411
    ],
    "odienné jula": [
        3411
    ],
    "odienné": [
        3411
    ],
    "ouorodougou": [
        3429
    ],
    "olga": [
        3434
    ],
    "okande": [
        3497
    ],
    "ostjak": [
        3506
    ],
    "ostyak": [
        3506,
        6786,
        3577
    ],
    "ofor": [
        3508
    ],
    "ojor": [
        3508
    ],
    "ouen": [
        3542
    ],
    "old khmer": [
        5890,
        3550,
        3551,
        3552
    ],
    "okela": [
        3569
    ],
    "ostiak": [
        3577
    ],
    "ocinkumbi": [
        3664
    ],
    "olungkhumbi": [
        3664
    ],
    "otjingumbi": [
        3664
    ],
    "ochikwanyama": [
        3694,
        3695
    ],
    "oshikuanjama": [
        3694,
        3695
    ],
    "oshikwanyama": [
        3694,
        3695
    ],
    "oshiwambo": [
        3695,
        3694,
        5420
    ],
    "otjiwambo": [
        3694,
        3695,
        4085,
        5420
    ],
    "ovambo": [
        3694,
        3695
    ],
    "owambo": [
        3694,
        3695,
        4085,
        5420
    ],
    "oxikuanyama": [
        3694,
        3695
    ],
    "orasi": [
        3712
    ],
    "ores": [
        3712
    ],
    "odoodee": [
        3737
    ],
    "ododei": [
        3737
    ],
    "ourekabakan": [
        3739,
        3740
    ],
    "ooe kokota": [
        3747
    ],
    "ooe": [
        3747
    ],
    "okonyong": [
        3749
    ],
    "okoyong": [
        3749
    ],
    "ogit": [
        3823
    ],
    "orang bukit": [
        3838,
        3839
    ],
    "orang liar": [
        3838,
        3839
    ],
    "olukonjo": [
        3863
    ],
    "olukonzo": [
        3863
    ],
    "okolod": [
        3919
    ],
    "okolod murut": [
        3919
    ],
    "ododop": [
        3940
    ],
    "oraoan": [
        3944
    ],
    "oraon": [
        6762,
        6763,
        6764,
        3944
    ],
    "orau": [
        3944
    ],
    "ok bari": [
        3999
    ],
    "ok": [
        3999
    ],
    "orang hutan": [
        4046
    ],
    "orang rimba": [
        4046
    ],
    "oshikwambi": [
        4085
    ],
    "orang sawang": [
        4244
    ],
    "omphai lawa": [
        4249
    ],
    "omphai": [
        4249
    ],
    "opo": [
        4307
    ],
    "olukhayo": [
        4368
    ],
    "ojwan-boii": [
        4369
    ],
    "olushisa": [
        4370
    ],
    "oirya": [
        4373
    ],
    "owoi": [
        4373
    ],
    "oxoriok": [
        4373
    ],
    "odyalombito": [
        4401
    ],
    "ohnhan": [
        4442
    ],
    "olombo": [
        4454
    ],
    "ollaran": [
        4455
    ],
    "otuho": [
        4459,
        4460
    ],
    "olotorit": [
        4459,
        4460
    ],
    "otuxo": [
        4459,
        4460
    ],
    "olumarachi": [
        4479
    ],
    "olumarama": [
        4482
    ],
    "olusamia": [
        4497
    ],
    "olutsotso": [
        4514
    ],
    "olu’bo": [
        4526
    ],
    "olu'bo": [
        4526
    ],
    "olubogo": [
        4526
    ],
    "oluboti": [
        4526
    ],
    "olu’boti": [
        4526
    ],
    "ondoe": [
        4526
    ],
    "oluluyia": [
        4540
    ],
    "oluwanga": [
        4550
    ],
    "oluhanga": [
        4550
    ],
    "oriente": [
        4599,
        5987,
        6251,
        6412,
        6424,
        6429
    ],
    "ombamba": [
        4611
    ],
    "ouaddai": [
        4655,
        4656
    ],
    "ouaddaien": [
        4655,
        4656
    ],
    "obamba": [
        4671
    ],
    "ocotepec": [
        4796,
        4686,
        9169
    ],
    "oré jawi": [
        4707,
        4708
    ],
    "oré": [
        4707,
        4708
    ],
    "oderiga": [
        4723
    ],
    "ofunobwam": [
        4723
    ],
    "okam": [
        4723
    ],
    "official malagasy": [
        4736,
        4738
    ],
    "ocotepec mixtec": [
        4796
    ],
    "obi": [
        4814
    ],
    "old mapian": [
        5008
    ],
    "oubièlo": [
        5020
    ],
    "oranje-gebergte": [
        5107
    ],
    "oktenai": [
        5116
    ],
    "obiye": [
        5212
    ],
    "omyene": [
        5235
    ],
    "otanabe": [
        5247
    ],
    "otanave": [
        5247
    ],
    "okebu": [
        5372
    ],
    "oke’bu": [
        5372
    ],
    "ochindonga": [
        5420
    ],
    "oshindonga": [
        5420
    ],
    "osindonga": [
        5420
    ],
    "ometepec": [
        5461
    ],
    "ometepec aztec": [
        5461
    ],
    "ometepec nahuatl": [
        5461
    ],
    "oruhuma": [
        5490
    ],
    "olunyala": [
        5546
    ],
    "orizaba": [
        5556
    ],
    "orizaba aztec": [
        5556
    ],
    "orizaba nahuatl": [
        5556
    ],
    "ondoumbo": [
        5564
    ],
    "ondumbo": [
        5564
    ],
    "orundande": [
        5592
    ],
    "opa": [
        5594
    ],
    "oshingandjera": [
        5595
    ],
    "old norse": [
        5631
    ],
    "olungendelengo": [
        5654
    ],
    "ovangendelengo": [
        5654
    ],
    "ongom": [
        5663
    ],
    "oormbur": [
        5679
    ],
    "ongamo": [
        5687
    ],
    "oshie": [
        5688
    ],
    "old signs": [
        5699
    ],
    "oodamicʌdʌ": [
        5718
    ],
    "o’otham": [
        5718,
        5937
    ],
    "old newari": [
        5758,
        5759,
        5760,
        5761,
        5762
    ],
    "obgwo": [
        5784
    ],
    "orgwo": [
        5784
    ],
    "olunyole": [
        5790
    ],
    "olunyore": [
        5790
    ],
    "olunyaneka": [
        5797
    ],
    "olunyankole": [
        5800
    ],
    "orok": [
        5822
    ],
    "oroc": [
        5822
    ],
    "oroch": [
        5823
    ],
    "orochi": [
        5823
    ],
    "old aramaic (up to 700 bce)": [
        5824
    ],
    "old avar": [
        5825
    ],
    "obispeño": [
        5826
    ],
    "oblo": [
        5828
    ],
    "obo": [
        5830
    ],
    "obo bagobo": [
        5830
    ],
    "obo manobo": [
        5830
    ],
    "old burmese": [
        5831
    ],
    "old breton": [
        5832
    ],
    "obulom": [
        5833
    ],
    "occitan": [
        5834,
        6295
    ],
    "occitán": [
        5834
    ],
    "occitan (post 1500)": [
        5834
    ],
    "occitani": [
        5834
    ],
    "ocaina": [
        5835
    ],
    "okaina": [
        5835
    ],
    "old chinese": [
        5836
    ],
    "old cham": [
        5837
    ],
    "old cornish": [
        5838
    ],
    "ocuiltec": [
        5839
    ],
    "ocuilteco": [
        5839
    ],
    "odut": [
        5840
    ],
    "oadki": [
        5841
    ],
    "oad": [
        5841
    ],
    "odh": [
        5841
    ],
    "odki": [
        5841
    ],
    "old dutch": [
        5842
    ],
    "odual": [
        5843,
        6932
    ],
    "onu oḍual": [
        5843
    ],
    "onu": [
        5843
    ],
    "oḍual": [
        5843
    ],
    "ofo": [
        5844
    ],
    "old frisian": [
        5845,
        5846
    ],
    "ofutop": [
        5847
    ],
    "ogbia": [
        5848
    ],
    "ogbinya": [
        5848
    ],
    "ogbah": [
        5849
    ],
    "ogba": [
        5849
    ],
    "olu ọgba": [
        5849
    ],
    "olu": [
        5849
    ],
    "old georgian": [
        5850
    ],
    "ogbogolo": [
        5851
    ],
    "obogolo": [
        5851
    ],
    "ogoni": [
        5852
    ],
    "ogbronuagum": [
        5853
    ],
    "obronuagum": [
        5853
    ],
    "old hittite": [
        5854
    ],
    "old hungarian": [
        5855,
        5856
    ],
    "oirata": [
        5857
    ],
    "one, inebu": [
        5858
    ],
    "ojibwa, eastern": [
        5859,
        5860
    ],
    "ojibwa, northwestern": [
        5861,
        5862
    ],
    "ojibwa, central": [
        5863
    ],
    "old japanese": [
        5864
    ],
    "oji-cree": [
        5865,
        5866
    ],
    "ojicree": [
        5865,
        5866
    ],
    "ontong java": [
        5867
    ],
    "ontong": [
        5867
    ],
    "ojibwa, western": [
        5868,
        5869
    ],
    "okanagan": [
        5870,
        5871
    ],
    "okanagan-colville": [
        5870,
        5871
    ],
    "okanagon": [
        5870,
        5871
    ],
    "okanogan": [
        5870,
        5871
    ],
    "okobo": [
        5872
    ],
    "okodia": [
        5874
    ],
    "okordia": [
        5874
    ],
    "okpe": [
        5875,
        5889
    ],
    "okpe (southwestern edo)": [
        5875
    ],
    "okiek": [
        5878
    ],
    "ogiek": [
        5878
    ],
    "oko-juwoi": [
        5879
    ],
    "oku-juwoi": [
        5879
    ],
    "one, kwamtim": [
        5880
    ],
    "old kentish sign language": [
        5881
    ],
    "oki-no-erabu": [
        5883
    ],
    "old korean (3rd-9th cent.)": [
        5884
    ],
    "okrika": [
        5885
    ],
    "oko-eni-osayen": [
        5886
    ],
    "ogori-magongo": [
        5886
    ],
    "oko": [
        5886
    ],
    "oku": [
        5887
    ],
    "orokaiva": [
        5888
    ],
    "okpe (northwestern edo)": [
        5889
    ],
    "olangchung gola": [
        5891
    ],
    "olangchung": [
        5891
    ],
    "old moshi": [
        5892
    ],
    "olekha": [
        5893
    ],
    "ole mönpa": [
        5893
    ],
    "ole": [
        5893
    ],
    "olkol": [
        5894
    ],
    "olkolo": [
        5894
    ],
    "olcoola": [
        5894
    ],
    "olgol": [
        5894
    ],
    "olgolo": [
        5894
    ],
    "olkola": [
        5894
    ],
    "olkulo": [
        5894
    ],
    "ol’kol": [
        5894
    ],
    "oloma": [
        5895
    ],
    "olonets": [
        5896
    ],
    "olonetsian": [
        5896
    ],
    "olrat": [
        5897
    ],
    "old lithuanian": [
        5898
    ],
    "olukuvale": [
        5899
    ],
    "oromoo": [
        5900,
        5902,
        5903
    ],
    "oromo, west central": [
        5900,
        5902
    ],
    "omaha-ponca": [
        5904
    ],
    "oba": [
        5905
    ],
    "omba": [
        5905
    ],
    "omagua-yete": [
        5907
    ],
    "omágua": [
        5907
    ],
    "omi": [
        5908
    ],
    "omok": [
        5909
    ],
    "ombo": [
        5910
    ],
    "osum": [
        5912
    ],
    "old manipuri": [
        5913
    ],
    "old marathi": [
        5914
    ],
    "omotik": [
        5915
    ],
    "omotic": [
        5915
    ],
    "omurano": [
        5916
    ],
    "omurana": [
        5916
    ],
    "old mon": [
        5918
    ],
    "old malay": [
        5919
    ],
    "ona": [
        5920
    ],
    "ong-be": [
        5921
    ],
    "ongbe": [
        5921
    ],
    "oneida": [
        5922
    ],
    "onʌyota’a:ka": [
        5922
    ],
    "olo": [
        5923
    ],
    "orlei": [
        5923
    ],
    "onin": [
        5924,
        5936
    ],
    "onim": [
        5924
    ],
    "onjob": [
        5925
    ],
    "onjab": [
        5925
    ],
    "onjou": [
        5925
    ],
    "one, kabore": [
        5926
    ],
    "onobasulu": [
        5927
    ],
    "onabasulu": [
        5927
    ],
    "onondaga": [
        5928
    ],
    "onandaga": [
        5928
    ],
    "ongwehonhwe": [
        5928
    ],
    "onoñda’géga’": [
        5928
    ],
    "one, northern": [
        5931
    ],
    "ono": [
        5932
    ],
    "ontenu": [
        5933
    ],
    "ontena": [
        5933
    ],
    "onua": [
        5934
    ],
    "old nubian": [
        5935
    ],
    "onin based pidgin": [
        5936
    ],
    "o’odham": [
        5937
    ],
    "oʼodham ha-ñeʼokĭ": [
        5937
    ],
    "oʼodham": [
        5937
    ],
    "oʼodham ñiok": [
        5937
    ],
    "o’othham": [
        5937
    ],
    "oodham": [
        5937
    ],
    "oorlams": [
        5940
    ],
    "old ossetic": [
        5941
    ],
    "ossetic": [
        5965,
        5966,
        5967,
        5941,
        5968
    ],
    "okpamheri": [
        5942
    ],
    "opameri": [
        5942
    ],
    "oksapmin": [
        5944
    ],
    "opao": [
        5945
    ],
    "opata": [
        5946
    ],
    "ofayé": [
        5947
    ],
    "ofaié": [
        5947
    ],
    "ofaié-xavante": [
        5947
    ],
    "ofayé-xavante": [
        5947
    ],
    "opaié-shavante": [
        5947
    ],
    "opayé": [
        5947
    ],
    "oriya (macrolanguage)": [
        5948,
        5949
    ],
    "odia": [
        5948,
        5949
    ],
    "odia (macrolanguage)": [
        5948,
        5949
    ],
    "odisha": [
        5948,
        5949
    ],
    "odri": [
        5948,
        5949
    ],
    "odrum": [
        5948,
        5949
    ],
    "oliya": [
        5948,
        5949
    ],
    "oroha": [
        5950
    ],
    "oraha": [
        5950
    ],
    "orma": [
        5951
    ],
    "oring": [
        5953
    ],
    "orri": [
        5953
    ],
    "orrin": [
        5953
    ],
    "orringorrin": [
        5953
    ],
    "oroqen": [
        5954
    ],
    "olunchun": [
        5954
    ],
    "orochen": [
        5954
    ],
    "orochon": [
        5954
    ],
    "oronchon": [
        5954
    ],
    "orang kanaq": [
        5955
    ],
    "orokolo": [
        5956
    ],
    "oruma": [
        5957
    ],
    "orang seletar": [
        5958
    ],
    "oriya, adivasi": [
        5959
    ],
    "ormuri": [
        5960
    ],
    "oormuri": [
        5960
    ],
    "ormar": [
        5960
    ],
    "ormari": [
        5960
    ],
    "ormui": [
        5960
    ],
    "ormur": [
        5960
    ],
    "old russian": [
        5961
    ],
    "oro win": [
        5962
    ],
    "oro": [
        5962,
        5963,
        6038
    ],
    "oto towati": [
        5962
    ],
    "oto": [
        5962
    ],
    "ormu": [
        5964
    ],
    "osetin": [
        5965,
        5966,
        5967
    ],
    "ossete": [
        5965,
        5966,
        5967
    ],
    "ossetian": [
        5968,
        5965,
        5966,
        5967
    ],
    "osage": [
        5969,
        5970
    ],
    "oscan": [
        5971,
        5972
    ],
    "osing": [
        5973
    ],
    "old sundanese": [
        5974
    ],
    "ososo": [
        5975
    ],
    "old spanish": [
        5976
    ],
    "osatu": [
        5977
    ],
    "ossatu": [
        5977
    ],
    "one, southern": [
        5978
    ],
    "old saxon": [
        5979
    ],
    "ottoman turkish (1500-1928)": [
        5980
    ],
    "ottoman": [
        5980
    ],
    "old tibetan": [
        5981
    ],
    "ot danum": [
        5982
    ],
    "ot": [
        5982,
        7266
    ],
    "otomi, mezquital": [
        5983
    ],
    "otomi": [
        5983,
        5986,
        5987,
        5988,
        5989,
        5992,
        5995,
        5997,
        5991
    ],
    "otomí del valle del mezquital": [
        5983
    ],
    "otomí": [
        5991,
        5983,
        5987,
        5988,
        5989,
        5995,
        5997
    ],
    "oti": [
        5984
    ],
    "otí": [
        5984
    ],
    "old turkish": [
        5985
    ],
    "otomi, tilapa": [
        5986
    ],
    "otomi, eastern highland": [
        5987
    ],
    "otomí de huehuetla": [
        5987
    ],
    "otomí de la sierra": [
        5987
    ],
    "otomí de la sierra madre oriental": [
        5987
    ],
    "otomí de la sierra oriental": [
        5987
    ],
    "otomí del oriente": [
        5987
    ],
    "otomi, tenango": [
        5988
    ],
    "otomí de tenango": [
        5988
    ],
    "otomi, querétaro": [
        5989
    ],
    "otomí de querétaro": [
        5989
    ],
    "otoro": [
        5990
    ],
    "otomí, estado de méxico": [
        5991
    ],
    "otomí de san felipe santiago": [
        5991
    ],
    "otomí del estado de méxico": [
        5991
    ],
    "otomi, temoaya": [
        5992
    ],
    "otomi of san andrés cuexcontitlan": [
        5992
    ],
    "otuke": [
        5993
    ],
    "otuké": [
        5993
    ],
    "otuque": [
        5993
    ],
    "otuqui": [
        5993
    ],
    "otuqué": [
        5993
    ],
    "ottawa": [
        5994
    ],
    "odawa": [
        5994
    ],
    "otomi, texcatepec": [
        5995
    ],
    "otomí de texcatepec": [
        5995
    ],
    "old tamil": [
        5996
    ],
    "otomi, ixtenco": [
        5997
    ],
    "otomí de ixtenco": [
        5997
    ],
    "ouargla": [
        5998
    ],
    "ouargli": [
        5998
    ],
    "oubi": [
        5999,
        7897
    ],
    "oune": [
        6000
    ],
    "ounge": [
        6000
    ],
    "old uighur": [
        6001,
        6002
    ],
    "ouma": [
        6003
    ],
    "owiniga": [
        6005
    ],
    "owininga": [
        6005
    ],
    "old welsh": [
        6006
    ],
    "oy": [
        6007
    ],
    "oey": [
        6007
    ],
    "oi": [
        6007,
        7762
    ],
    "oi-sok": [
        6007
    ],
    "oyda": [
        6008
    ],
    "oiampí": [
        6009
    ],
    "oiumpian": [
        6009
    ],
    "oyampí": [
        6009
    ],
    "oyampík": [
        6009
    ],
    "oyanpík": [
        6009
    ],
    "oyapí": [
        6009
    ],
    "oya’oya": [
        6010
    ],
    "oya'oya": [
        6010
    ],
    "oro wari": [
        6038
    ],
    "orowari": [
        6038
    ],
    "oium": [
        6053
    ],
    "old persian (ca. 600-400 b.c.)": [
        6101
    ],
    "oob no’ok": [
        6142
    ],
    "oob": [
        6142
    ],
    "oluta": [
        6193
    ],
    "oluta mijean": [
        6193
    ],
    "oluta popoluca": [
        6193
    ],
    "olutec": [
        6193
    ],
    "out": [
        6203
    ],
    "otlaltepec": [
        6265
    ],
    "oema": [
        6270
    ],
    "old prussian": [
        6288
    ],
    "old provençal (to 1500)": [
        6295
    ],
    "old occitan (to 1500)": [
        6295
    ],
    "ogan": [
        6311
    ],
    "ogaxpa": [
        6396
    ],
    "otavalo quichua": [
        6419
    ],
    "otavalo": [
        6419
    ],
    "orig": [
        6473
    ],
    "orelhas de pau": [
        6533
    ],
    "orelhas": [
        6533
    ],
    "olvɨeŋgɨ in’ambreŋgɨ": [
        6549
    ],
    "olvɨeŋgɨ": [
        6549
    ],
    "oe nale": [
        6595
    ],
    "okhu-in": [
        6610,
        6612
    ],
    "olossu": [
        6610,
        6612
    ],
    "orunyarwanda": [
        6635,
        6636
    ],
    "oosima": [
        6646
    ],
    "osima": [
        6646
    ],
    "okinawan, central": [
        6648
    ],
    "okinawan": [
        6648
    ],
    "oraon sadri": [
        6762,
        6763,
        6764
    ],
    "onödowá’ga:": [
        6778
    ],
    "ostyak samoyed": [
        6786
    ],
    "old irish (to 900)": [
        6805,
        6806
    ],
    "oasis berber": [
        6888
    ],
    "oasis": [
        6888
    ],
    "orang cagayan": [
        6896
    ],
    "okwasar": [
        7111
    ],
    "ould": [
        7164
    ],
    "owa": [
        7171
    ],
    "oꞌdam": [
        7173
    ],
    "o’dam": [
        7173
    ],
    "olusuba": [
        7253
    ],
    "obersächsisch": [
        7264
    ],
    "ot siang": [
        7266
    ],
    "osamayi": [
        7280
    ],
    "oa": [
        7321
    ],
    "omo": [
        7448
    ],
    "olubwisi": [
        7570
    ],
    "otetela": [
        7572
    ],
    "ohañara": [
        7617
    ],
    "opaina": [
        7617
    ],
    "onik": [
        7629
    ],
    "ozumatlán totonac": [
        7691
    ],
    "ozumatlán": [
        7691
    ],
    "ozomatlán": [
        7691
    ],
    "osmanli": [
        7694,
        7695,
        7696,
        7698,
        7699
    ],
    "otomb": [
        7760
    ],
    "orutoro": [
        7764
    ],
    "old kanembu": [
        7847
    ],
    "o’du": [
        7863
    ],
    "o du": [
        7863
    ],
    "o": [
        7863
    ],
    "o'du": [
        7863
    ],
    "oedou": [
        7863
    ],
    "oxchuc tzeltal": [
        7880
    ],
    "oxchuc": [
        7880
    ],
    "oubykh": [
        7903,
        7904
    ],
    "ouldeme": [
        7910
    ],
    "othan": [
        7913
    ],
    "oehoendoeni": [
        7927
    ],
    "olch": [
        7946
    ],
    "olcha": [
        7946
    ],
    "olchis": [
        7946
    ],
    "oeloemanda": [
        7952
    ],
    "oma longh": [
        7954
    ],
    "oma": [
        7954
    ],
    "olumbali": [
        7957
    ],
    "ovimbundu": [
        7957
    ],
    "ompindamo": [
        7959
    ],
    "omotina": [
        7964
    ],
    "onank": [
        7968
    ],
    "oruarinya": [
        7992
    ],
    "oroarina": [
        7992
    ],
    "otati": [
        7996
    ],
    "origanau": [
        7997
    ],
    "olang lawta": [
        8000
    ],
    "olang": [
        8000
    ],
    "orak lawoi’": [
        8000
    ],
    "orak": [
        8000
    ],
    "oorazhi": [
        8001
    ],
    "orya": [
        8012
    ],
    "oria": [
        8012
    ],
    "otank": [
        8022
    ],
    "otang": [
        8022
    ],
    "otanga": [
        8022
    ],
    "ouvean": [
        8033
    ],
    "o‘zbek": [
        8038
    ],
    "ouzbek": [
        8038,
        8039,
        8040,
        8042,
        8043
    ],
    "o’zbek": [
        8038,
        8039,
        8040,
        8042,
        8043,
        8044
    ],
    "oʻzbek": [
        8038,
        8039,
        8040,
        8042,
        8043
    ],
    "oʻzbek tili": [
        8038,
        8039,
        8040,
        8042,
        8043
    ],
    "oʻzbekcha": [
        8038,
        8039,
        8040,
        8042,
        8043
    ],
    "oombarrmbarum": [
        8105
    ],
    "ostfränkisch": [
        8109
    ],
    "opselan": [
        8120
    ],
    "ouayeone": [
        8171
    ],
    "oayana": [
        8173
    ],
    "oiana": [
        8173
    ],
    "oyana": [
        8173
    ],
    "ouala": [
        8178,
        8269
    ],
    "ouara": [
        8178
    ],
    "orh": [
        8188
    ],
    "ouatchi": [
        8195
    ],
    "ouémé": [
        8208
    ],
    "oemale": [
        8209
    ],
    "ongkonguru": [
        8219
    ],
    "ombule": [
        8275
    ],
    "oonoomurra": [
        8296
    ],
    "ouolof": [
        8302,
        8303
    ],
    "ouobe": [
        8305
    ],
    "oageva": [
        8306
    ],
    "ong komi": [
        8332,
        8470
    ],
    "owenia": [
        8349
    ],
    "owena": [
        8349
    ],
    "owenda": [
        8349
    ],
    "oorongie": [
        8384
    ],
    "oirat": [
        8698,
        8398,
        8399
    ],
    "oost-sumbaas": [
        8424
    ],
    "olungbura": [
        8426
    ],
    "olukwandu": [
        8448
    ],
    "ovakwandu": [
        8448
    ],
    "o’o moko": [
        8459
    ],
    "o’o": [
        8459
    ],
    "ongaranjan": [
        8470
    ],
    "oengsongi": [
        8506
    ],
    "oost-mori": [
        8555
    ],
    "o’chi’chi’": [
        8575
    ],
    "o'chi'chi'": [
        8575
    ],
    "oderago": [
        8576
    ],
    "olusoga": [
        8577
    ],
    "okmaŋɨheŋgi": [
        8578
    ],
    "oyster bay tasmanian": [
        8591
    ],
    "oyster": [
        8591
    ],
    "oktengban": [
        8649
    ],
    "ongkarango": [
        8679,
        8673
    ],
    "o:ka:ta": [
        8673
    ],
    "o:kada": [
        8673
    ],
    "okat": [
        8673
    ],
    "oken": [
        8673
    ],
    "okwata": [
        8673
    ],
    "oomida": [
        8673
    ],
    "oonggarrangoo": [
        8679
    ],
    "ombessa": [
        8738
    ],
    "okurikan": [
        8744
    ],
    "oohum": [
        8754
    ],
    "ohalo": [
        8799
    ],
    "odul": [
        8816,
        8940
    ],
    "old sirenik": [
        8911
    ],
    "owanguttha": [
        8960
    ],
    "ocotlán": [
        8971,
        9141
    ],
    "ocotlán oeste zapotec": [
        8971
    ],
    "ocotlán zapotec": [
        8971
    ],
    "ozolotepec": [
        8983
    ],
    "ozolotepec zapotec": [
        8983
    ],
    "omuchizinza": [
        9056
    ],
    "orang negeri": [
        9089
    ],
    "o’de pʌt": [
        9113,
        9118,
        9119
    ],
    "o’de": [
        9113,
        9118,
        9119
    ],
    "oote": [
        9117
    ],
    "otetzame": [
        9119,
        9118
    ]
};
